import { useEffect, useState } from 'react';

// import isMaintenanceExceptionIpFetcher from '@/api/fetchers/maintenance/is-maintenance-exception-ip.fetcher';

const parseBoolean = (value: string): boolean | null => {
    switch (value) {
        case 'true':
            return true;
        case 'false':
            return false;
        default:
            return null;
    }
};

type UseMaintenanceException = () => {
    isMaintenanceException: boolean;
    hasMaintenance: boolean;
    loading: boolean;
};

const useMaintenanceException: UseMaintenanceException = () => {
    const [isLoading, setLoading] = useState<boolean>(true);

    const [isMaintenanceException, setMaintenanceException] = useState<boolean | null>(null);

    useEffect((): void => {
        console.log('import.meta.env.VITE_APP_MAINTENANCE', import.meta.env.VITE_APP_MAINTENANCE);
        if (import.meta.env.VITE_APP_MAINTENANCE === false) {
            console.log('import.meta.env.VITE_APP_MAINTENANCE === false');
            setLoading(false);
            return;
        }

        setMaintenanceException(false);
        setLoading(false);
        // if needed add check for user/ip exeption
        // isMaintenanceExceptionIpFetcher()
        //     .then((isException: boolean): void => {
        //         setMaintenanceException(isException);
        //     })
        //     .finally((): void => {
        //         setLoading(false);
        //     });
    }, []);

    return {
        isMaintenanceException: isMaintenanceException ?? false,
        hasMaintenance: parseBoolean(import.meta.env.VITE_APP_MAINTENANCE) ?? false,
        loading: isLoading,
    };
};

export default useMaintenanceException;
